import { normalizeProjectUrl } from "./atsCvProjectLink.js";

/** Contact glyph size in PDF (mm) — matches ~10px preview icons */
export const PDF_CONTACT_ICON_MM = 2.8;

const ICON_PX = 24;

const CONTACT_SVG = {
    location: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#222222" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>`,
    email: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#222222" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.7 28.4 19.3 36.3L256 352l236.7-203.7c11.6-7.9 19.3-21.2 19.3-36.3c0-26.5-21.5-48-48-48H48zM0 176v208c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg>`,
    phone: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#222222" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448c18 0 33.8-12.1 38.5-29.4l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C230.1 293.3 218.7 287.5 144.3 212.9L103 164.3c-13.7-11.2-18.4-30-11.6-46.3l40-96z"/></svg>`,
    linkedin: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#222222" d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>`,
    website: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#222222" d="M352 256c0 22.2-1.2 43.6-3.3 64H259.7c1.1-20.8 1.7-42.1 1.7-64s-.6-43.2-1.7-64h88.9c2.1 20.4 3.3 41.8 3.3 64zm-93.9 160.5c-9.8 32.4-22.8 58.4-37.1 74.1-14.3-15.7-27.3-41.7-37.1-74.1-8.5-28.4-13.6-59.7-14.9-91.5H306c-1.3 31.8-6.4 63.1-14.9 91.5zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zM97.3 352c-8.5-28.4-13.6-59.7-14.9-91.5H32.1c1.3 31.8 6.4 63.1 14.9 91.5 9.8 32.4 22.8 58.4 37.1 74.1 14.3-15.7 27.3-41.7 37.1-74.1zm14.9-91.5c1.3-31.8 6.4-63.1 14.9-91.5 9.8-32.4 22.8-58.4 37.1-74.1 14.3 15.7 27.3 41.7 37.1 74.1 8.5 28.4 13.6 59.7 14.9 91.5H112.2zm133.7 160.5c14.3 15.7 27.3 41.7 37.1 74.1 14.3-15.7 27.3-41.7 37.1-74.1 8.5-28.4 13.6-59.7 14.9-91.5H230.9c1.3 31.8 6.4 63.1 14.9 91.5zM416 160.5c-8.5 28.4-13.6 59.7-14.9 91.5h-79.2c1.3-31.8 6.4-63.1 14.9-91.5 9.8-32.4 22.8-58.4 37.1-74.1-14.3 15.7-27.3 41.7-37.1 74.1zm-37.1-74.1c-14.3-15.7-27.3-41.7-37.1-74.1-9.8 32.4-22.8 58.4-37.1 74.1 14.3 15.7 27.3 41.7 37.1 74.1 8.5 28.4 13.6 59.7 14.9 91.5h79.2c-1.3-31.8-6.4-63.1-14.9-91.5z"/></svg>`,
};

const PNG_CACHE = new Map();

/**
 * @param {string} svgMarkup
 * @param {number} pixelSize
 */
function rasterizeSvgToPng(svgMarkup, pixelSize = ICON_PX) {
    const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgMarkup)}`;
    const cacheKey = `${svgDataUrl}|${pixelSize}`;
    if (PNG_CACHE.has(cacheKey)) {
        return Promise.resolve(PNG_CACHE.get(cacheKey));
    }

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                canvas.width = pixelSize;
                canvas.height = pixelSize;
                const ctx = canvas.getContext("2d");
                if (!ctx) {
                    reject(new Error("Canvas unsupported"));
                    return;
                }
                ctx.clearRect(0, 0, pixelSize, pixelSize);
                ctx.drawImage(img, 0, 0, pixelSize, pixelSize);
                const png = canvas.toDataURL("image/png");
                PNG_CACHE.set(cacheKey, png);
                resolve(png);
            } catch (err) {
                reject(err);
            }
        };
        img.onerror = () => reject(new Error("Contact icon rasterize failed"));
        img.src = svgDataUrl;
    });
}

/** @returns {Promise<Record<string, string>>} */
export async function preloadContactIconPngs() {
    const entries = await Promise.all(
        Object.entries(CONTACT_SVG).map(async ([key, svg]) => [
            key,
            await rasterizeSvgToPng(svg),
        ])
    );
    return Object.fromEntries(entries);
}

/**
 * @param {"location"|"email"|"phone"|"linkedin"|"website"} type
 * @param {string} text
 */
export function getContactHref(type, text) {
    const raw = String(text ?? "").trim();
    if (!raw) return "";
    switch (type) {
        case "email":
            return `mailto:${raw}`;
        case "phone": {
            const digits = raw.replace(/[^\d+]/g, "");
            return digits ? `tel:${digits}` : "";
        }
        case "linkedin":
        case "website":
            return normalizeProjectUrl(raw);
        default:
            return "";
    }
}

/**
 * @typedef {{ type: string, text: string }} ContactItem
 */

/**
 * @param {import("jspdf").jsPDF} pdf
 * @param {number} y
 * @param {ContactItem[]} items
 * @param {Record<string, string> | null} icons
 * @param {string} fontName
 * @returns {number}
 */
export function writePdfContactRow(pdf, y, items, icons, fontName = "times") {
    if (!items.length) return y;

    y = ensurePdfSpace(pdf, y, 5);
    const pageW = pdf.internal.pageSize.getWidth();
    const iconMm = PDF_CONTACT_ICON_MM;
    const iconGap = 1;
    const sep = "  |  ";
    const lineH = 4.2;

    pdf.setFont(fontName, "normal");
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);

    const sepW = pdf.getTextWidth(sep);
    let totalW = 0;
    for (let i = 0; i < items.length; i++) {
        if (i > 0) totalW += sepW;
        const hasIcon = Boolean(icons?.[items[i].type]);
        totalW += (hasIcon ? iconMm + iconGap : 0) + pdf.getTextWidth(items[i].text);
    }

    let x = (pageW - totalW) / 2;
    const baselineY = y;
    const iconTop = baselineY - iconMm * 0.82;

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (i > 0) {
            pdf.text(sep, x, baselineY);
            x += sepW;
        }

        const png = icons?.[item.type];
        if (png) {
            pdf.addImage(png, "PNG", x, iconTop, iconMm, iconMm, undefined, "FAST");
            x += iconMm + iconGap;
        }

        const blockStartX = x;
        const textW = pdf.getTextWidth(item.text);
        const href = getContactHref(item.type, item.text);

        if (href && typeof pdf.textWithLink === "function") {
            pdf.textWithLink(item.text, x, baselineY, { url: href });
        } else {
            pdf.text(item.text, x, baselineY);
        }

        if (href && typeof pdf.link === "function") {
            const blockW = x - blockStartX + textW;
            const linkH = 4.6;
            const linkY = baselineY - 3.4;
            pdf.link(blockStartX, linkY, blockW, linkH, { url: href });
        }

        x += textW;
    }

    return y + lineH;
}

/** @param {import("jspdf").jsPDF} pdf */
function ensurePdfSpace(pdf, y, needed) {
    const PAGE_BOTTOM = 284;
    const MARGIN_TOP = 13;
    if (y + needed > PAGE_BOTTOM) {
        pdf.addPage();
        return MARGIN_TOP;
    }
    return y;
}
